import type { Theme } from '@mui/material';

export const getConditionalMeasurementColor = (
  hasCriteria: boolean | undefined,
  status: 'success' | 'warning' | 'error' | undefined,
  theme: Theme,
  color?: string
): string | undefined => {
  const defaultColor = color ?? theme.palette.text.primary;
  switch (true) {
    case !hasCriteria:
    case status === undefined:
    case status === 'success':
      return theme.mode === 'dark' ? (color ? defaultColor : 'inherit') : defaultColor;
    case status === 'warning':
      return theme.palette.warning.main;
    default:
      return theme.palette.error.main;
  }
};

const getConditionalHighlighting = (
  isHighlighted: boolean,
  theme: Theme,
  status?: 'success' | 'warning' | 'error',
  color?: string
): object => {
  const defaultColor: string = color ?? theme.palette.text.primary;
  return isHighlighted
    ? {
        color: color
          ? color
          : (theme.contrastFont ??
            (status === undefined || status === 'success'
              ? defaultColor
              : status === 'warning'
                ? theme.palette.warning.main
                : theme.palette.error.main))
      }
    : {};
};

export const getConditionalStyles = (
  isHighlighted: boolean,
  theme: Theme,
  tdStyles?: object,
  thStyles?: object,
  status?: 'success' | 'warning' | 'error',
  color?: string
): object => {
  const isDarkMode = theme.mode === 'dark';

  return {
    backgroundColor: isHighlighted ? theme.customPalette.panels.tableRowHighlighted : 'inherit',
    '& > td': {
      ...getConditionalHighlighting(isHighlighted, theme, status),
      ...(tdStyles || {})
    },
    '& > th': {
      ...getConditionalHighlighting(isHighlighted, theme, status, color),
      ...(thStyles || {})
    },
    '& input': getConditionalHighlighting(isHighlighted, theme, status),
    ...(isDarkMode ? { '& svg:not(.criteria)': { color: isHighlighted ? 'rgba(0, 0, 0, 0.6)' : 'inherit' } } : {})
  };
};
